import React, { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import {
  deleteContactGroup,
  deleteContactGroupEmails,
  updateContactGroup,
  updateContactGroupEmails,
} from "../../service/api";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import styles from "./index.module.css";
import { useForm } from "react-hook-form";
import Select from "react-select";
import styles2 from "../../pages/proformaUser/addProforma.module.css";
import { IoIosClose } from "react-icons/io";
import { showNotification } from "../../service/showNotification";
import { yupResolver } from "@hookform/resolvers/yup";
import { emailValidationSchema } from "../../yup";

const scenerioOptions = [
  { label: "0%", value: "0" },
  { label: "0.5%", value: "0.5" },
  { label: "1%", value: "1" },
  { label: "1.5%", value: "1.5" },
  { label: "2%", value: "2" },
  { label: "2.5%", value: "2.5" },
  { label: "3%", value: "3" },
  { label: "3.5%", value: "3.5" },
  { label: "4%", value: "4" },
  { label: "4.5%", value: "4.5" },
  { label: "5%", value: "5" },
  { label: "5.5%", value: "5.5" },
  { label: "6%", value: "6" },
  { label: "6.5%", value: "6.5" },
  { label: "7%", value: "7" },
  { label: "7.5%", value: "7.5" },
  { label: "8%", value: "8" },
  { label: "8.5%", value: "8.5" },
  { label: "9%", value: "9" },
  { label: "9.5%", value: "9.5" },
  { label: "10%", value: "10" },
  { label: "10.5%", value: "10.5" },
  { label: "11%", value: "11" },
  { label: "11.5%", value: "11.5" },
  { label: "12%", value: "12" },
  { label: "12.5%", value: "12.5" },
  { label: "13%", value: "13" },
  { label: "13.5%", value: "13.5" },
  { label: "14%", value: "14" },
  { label: "14.5%", value: "14.5" },
  { label: "15%", value: "15" },
  { label: "15.5%", value: "15.5" },
  { label: "16%", value: "16" },
  { label: "16.5%", value: "16.5" },
  { label: "17%", value: "17" },
  { label: "17.5%", value: "17.5" },
  { label: "18%", value: "18" },
  { label: "18.5%", value: "18.5" },
  { label: "19%", value: "19" },
  { label: "19.5%", value: "19.5" },
  { label: "20%", value: "20" },
];

const ContactGroupTable = ({
  data,
  fetchContactGroup,
  getUsers,
  contactOptions,
}) => {
  const { register, reset, handleSubmit } = useForm();
  const {
    register: registerEmail,
    reset: resetEmail,
    handleSubmit: handleEmailSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(emailValidationSchema),
  });
  const [userData, setUserData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [emails, setEmails] = useState([]);
  const [selectedLowScenerioOptions, setSelectedLowScenerioOptions] = useState(
    scenerioOptions[0]
  );
  const [selectedLowMidScenerioOptions, setSelectedLowMidScenerioOptions] =
    useState(scenerioOptions[0]);
  const [selectedHighMidScenerioOptions, setSelectedHighMidScenerioOptions] =
    useState(scenerioOptions[0]);
  const [selectedHighScenerioOptions, setSelectedHighScenerioOptions] =
    useState(scenerioOptions[0]);
  const [additionalContactGroups, setAdditionalContactGroups] = useState([]);
  const [editItemId, setEditItemId] = useState("");
  const setUser = async (item) => {
    setIsEdit(true);
    setEditItemId(item._id);
    reset({
      developerDevFee: item?.developerDevFee,
      itcPercent: item?.itcPercent,
      folderId: item?.folderId,
      contactGroupName: item.contactGroupName,
      tsaOverride: item?.tsaOverride,
    });
    setEmails(item?.emails ?? []);

    setSelectedLowScenerioOptions({
      value: item.lowScenerio,
      label: item.lowScenerio + "%",
    });
    setSelectedLowMidScenerioOptions({
      value: item.lowMidScenerio,
      label: item.lowMidScenerio + "%",
    });
    setSelectedHighMidScenerioOptions({
      value: item.highMidScenerio,
      label: item.highMidScenerio + "%",
    });
    setSelectedHighScenerioOptions({
      value: item.highScenerio,
      label: item.highScenerio + "%",
    });
    const selectedGroups = contactOptions?.filter((option) =>
      item.additionalContactGroups.includes(option.label)
    );

    setAdditionalContactGroups(selectedGroups);
  };

  const deleteUser = async (id) => {
    try {
      await deleteContactGroup(id);
      fetchContactGroup();
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async (values) => {
    try {
      const payload = {
        _id: editItemId,
        contactGroupName: values.contactGroupName,
        folderId: values.folderId,
        developerDevFee: values.developerDevFee,
        itcPercent: values.itcPercent,
        lowScenerio: selectedLowScenerioOptions.value,
        lowMidScenerio: selectedLowMidScenerioOptions.value,
        highMidScenerio: selectedHighMidScenerioOptions.value,
        highScenerio: selectedHighScenerioOptions.value,
        additionalContactGroups: additionalContactGroups.map((c) => c.value),
        tsaOverride: values.tsaOverride,
      };

      const response = await updateContactGroup(payload);
      if (response.data.success) {
        setIsEdit(false);
        fetchContactGroup();
        getUsers();
        showNotification("success", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const removeEmail = async (id, value) => {
    const oldEmails = emails;
    try {
      const updatedEmails = emails?.filter((email) => email !== value);
      setEmails(updatedEmails);
      const response = await deleteContactGroupEmails(id, value);
      if (response.data.success) {
        fetchContactGroup();
        getUsers();
        showNotification("success", response.data.message);
      }
    } catch (error) {
      setEmails(oldEmails);
      console.log(error);
      showNotification("error", "Failed to delete email");
    }
    // deleteContactGroupEmails
  };
  const onEmailSubmit = async (values) => {
    try {
      const response = await updateContactGroupEmails({
        _id: editItemId,
        email: values.email,
      });
      if (response.data.success) {
        setIsEdit(false);
        fetchContactGroup();
        resetEmail({ email: "" });
        showNotification("success", response.data.message);
      }
    } catch (error) {
      console.log(error);
      showNotification("error", "Failed to save email");
    }
  };
  useEffect(() => {
    if (data.length > 0) {
      setUserData(data);
    }
  }, [data]);

  return (
    <>
      <div className="scrollable-table-container2">
        <Card
          border="light"
          className="table-wrapper table-responsive shadow-sm"
        >
          <Card.Body className="pt-0">
            <Table hover className="user-table align-items-center">
              <thead>
                <tr>
                  <th>Contact Group Name</th>
                  <th>Low Scenerio %</th>
                  <th>Low-Mid Scenerio %</th>
                  <th>High-Mid Scenerio %</th>
                  <th>High Scenerio %</th>
                  <th>Developer Dev Fee %</th>
                  <th>ITC %</th>
                  <th>Additional Contact Groups</th>
                  <th>TSA Override $/kW</th>
                  <th>FolderId</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {userData?.length <= 0 ? (
                  <tr>
                    <td className="text-center bg-grey" colSpan={100}>
                      No Records Found.
                    </td>
                  </tr>
                ) : (
                  userData.map((item) => {
                    return (
                      <tr key={item._id}>
                        <td>{item.contactGroupName}</td>
                        <td>
                          {item?.lowScenerio ? `${item?.lowScenerio}%` : "-"}
                        </td>
                        <td>
                          {item?.lowMidScenerio
                            ? `${item?.lowMidScenerio}%`
                            : "-"}
                        </td>
                        <td>
                          {item?.highMidScenerio
                            ? `${item?.highMidScenerio}%`
                            : "-"}
                        </td>
                        <td>
                          {item?.highScenerio ? `${item?.highScenerio}%` : "-"}
                        </td>
                        <td>{item?.developerDevFee ?? "-"}</td>
                        <td>{item?.itcPercent ?? "-"}</td>
                        <td className={styles.additionalContactGroups}>
                          <ContactGroupsDisplay
                            groups={item?.additionalContactGroups}
                          />
                        </td>

                        <td>
                          {item?.tsaOverride ? `$${item?.tsaOverride}` : "-"}
                        </td>
                        <td>{item?.folderId}</td>
                        <td>
                          <span>
                            <FaEdit
                              className={styles.editButton}
                              onClick={() => setUser(item)}
                            />
                          </span>
                          <span>
                            <MdDelete
                              className={styles.deleteButton}
                              onClick={() => deleteUser(item._id)}
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
      {isEdit && (
        <div className={styles.overlay}>
          <div className={styles.overlayContent}>
            <p className={styles.closeBtn} onClick={() => setIsEdit(false)}>
              <IoIosClose />
            </p>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className={styles.outerFormContainer}
            >
              <p className={styles2.heading}>Update User</p>
              <div className={styles2.formContainer}>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>
                    Contact Group Name
                  </label>
                  <input
                    disabled
                    {...register("contactGroupName")}
                    className={styles2.inputBox}
                    placeholder="Enter Contact Group name"
                    type="text"
                  />
                </div>

                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>
                    Developer Dev Fee %
                  </label>
                  <input
                    {...register("developerDevFee")}
                    className={styles2.inputBox}
                    placeholder="Enter Developer Dev Fee %"
                    type="text"
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}> ITC %</label>
                  <input
                    {...register("itcPercent")}
                    className={styles2.inputBox}
                    placeholder="Enter ITC %"
                    type="text"
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>
                    Destination Folder ID
                  </label>
                  <input
                    {...register("folderId")}
                    className={styles2.inputBox}
                    placeholder="Enter folder ID"
                    type="text"
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>Low Scenerio %</label>
                  <Select
                    options={scenerioOptions}
                    value={{
                      value: selectedLowScenerioOptions.value,
                      label: selectedLowScenerioOptions.label,
                    }}
                    onChange={(selected) =>
                      setSelectedLowScenerioOptions(selected)
                    }
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>
                    Low-Mid Scenerio %
                  </label>
                  <Select
                    options={scenerioOptions}
                    value={{
                      value: selectedLowMidScenerioOptions.value,
                      label: selectedLowMidScenerioOptions.label,
                    }}
                    onChange={(selected) =>
                      setSelectedLowMidScenerioOptions(selected)
                    }
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>
                    High-Mid Scenerio %
                  </label>
                  <Select
                    options={scenerioOptions}
                    value={{
                      value: selectedHighMidScenerioOptions.value,
                      label: selectedHighMidScenerioOptions.label,
                    }}
                    onChange={(selected) =>
                      setSelectedHighMidScenerioOptions(selected)
                    }
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>High Scenerio %</label>
                  <Select
                    options={scenerioOptions}
                    value={{
                      value: selectedHighScenerioOptions.value,
                      label: selectedHighScenerioOptions.label,
                    }}
                    onChange={(selected) =>
                      setSelectedHighScenerioOptions(selected)
                    }
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>
                    TSA Override $/kW
                  </label>
                  <input
                    {...register("tsaOverride")}
                    className={styles2.inputBox}
                    placeholder="Enter TSA Override $/kW"
                    type="text"
                  />
                </div>
                <div className={styles2.inputContainer}>
                  <label className={styles2.labelStyle}>
                    Additional Contact Groups{" "}
                  </label>
                  <Select
                    isMulti
                    options={contactOptions.filter(
                      (option) =>
                        option.label !==
                        userData.find((item) => item._id === editItemId)
                          ?.contactGroupName
                    )}
                    value={additionalContactGroups}
                    onChange={(selected) =>
                      setAdditionalContactGroups(selected || [])
                    }
                  />
                </div>
              </div>
              <input className={styles2.submitButton} type="submit" />
            </form>
            <form
              onSubmit={handleEmailSubmit(onEmailSubmit)}
              className={styles.outerFormContainer}
            >
              <p className={styles2.heading}>Add Email for Notifications</p>
              <div className={styles2.emailContainer}>
                <label className={styles2.labelStyle}>Email</label>
                <textarea
                  {...registerEmail("email")}
                  rows={4}
                  className={styles2.inputBoxEmail}
                  placeholder="Enter email(s)"
                  type="text"
                />
              </div>
              {errors.email && (
                <p className={styles.error}>{errors.email.message}</p>
              )}
              <div className={styles.chipContainer}>
                {emails.map((email, index) => (
                  <div key={index} className={styles.chip}>
                    <button
                      type="button"
                      className={styles.closeButton}
                      onClick={() => removeEmail(editItemId, email)}
                    >
                      ✕
                    </button>
                    <span className={styles.chipText}>{email}</span>
                  </div>
                ))}
              </div>
              <input className={styles2.submitButton} type="submit" />
            </form>
            {/* {watch("email")?.trim().split(/\s+/).length > 0 &&
                watch("email")
                  ?.trim()
                  .split(/\s+/)
                  .map((item, index) => (
                    <span key={index} className={styles.emails}>
                      {item}
                    </span>
                  ))} */}
          </div>
        </div>
      )}
    </>
  );
};

export default ContactGroupTable;
const ContactGroupsDisplay = ({ groups }) => {
  if (!groups || groups.length === 0) {
    return <span>-</span>;
  }

  const grouped = groups.reduce((acc, curr, idx) => {
    const chunkIndex = Math.floor(idx / 3);
    if (!acc[chunkIndex]) acc[chunkIndex] = [];
    acc[chunkIndex].push(curr);
    return acc;
  }, []);

  return (
    <div className={styles.additionalContactGroups}>
      {grouped.map((group, idx) => (
        <p className={styles.groupLine} key={idx}>
          {group.join(", ")}
        </p>
      ))}
    </div>
  );
};
